import { render, staticRenderFns } from "./CompensationYear.vue?vue&type=template&id=3dc6d1ee&scoped=true"
import script from "./CompensationYear.vue?vue&type=script&lang=js"
export * from "./CompensationYear.vue?vue&type=script&lang=js"
import style0 from "./CompensationYear.vue?vue&type=style&index=0&id=3dc6d1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6d1ee",
  null
  
)

export default component.exports